// sliceFactory.js
import { createSlice } from "@reduxjs/toolkit";



//new added by M 12-01-2024

const getKeyFromMetaArg = (arg) => {
  if (!arg) return null;

  if (arg.orderStage !== undefined) {
    return `${arg.orderStage}`;
  }
  return null;
};
//new added by M 12-01-2024

// For list-type slices (list, pageInfo, count)
export const createDynamicSlice = ({
  name,
  thunk,
  listMode = false,
  keyedById = false,
  resetActionName,
  extraReducers = {},
}) => {
  const initialState = {
    loading: false,
    error: null,
    ...(listMode
      ? keyedById
        ? {
            list: {},
            pageInfo: {},
            count: {},
          }
        : {
            list: null,
            pageInfo: null,
            count: null,
          }
      : keyedById
      ? {
          data: {},
        }
      : {
          data: null,
        }),
  };

  const slice = createSlice({
    name,
    initialState,
    reducers: {
      ...(resetActionName && {
        [resetActionName]: (state) => {
          return initialState;
        },
      }),
    },
    extraReducers: (builder) => {
      builder
        .addCase(thunk.pending, (state) => {
          state.loading = true;
          state.error = null;
        })
        .addCase(thunk.fulfilled, (state, action) => {
          state.loading = false;

          if (listMode) {
            if (keyedById) {
              const key = getKeyFromMetaArg(action.meta?.arg);
              if (key !== null) {
                state.list[key] = action.payload?.list ?? [];
                state.pageInfo[key] = action.payload?.pageInfo ?? null;
                state.count[key] = action.payload?.count ?? null;
              }
            } else {
              state.list = action.payload?.list ?? [];
              state.pageInfo = action.payload?.pageInfo ?? null;
              state.count = action.payload?.count ?? null;
            }
          } else {
            if (keyedById) {
              const key = getKeyFromMetaArg(action.meta?.arg);
              if (key !== null) {
                state.data[key] = action.payload ?? null;
              }
            } else {
              state.data = action.payload ?? null;
            }
          }
        })
        .addCase(thunk.rejected, (state, action) => {
          state.loading = false;
          state.error =
            action.payload || action.error?.message || "Something went wrong";

          if (listMode) {
            if (keyedById) {
              const key = getKeyFromMetaArg(action.meta?.arg);
              if (key !== null) {
                state.list[key] = [];
                state.pageInfo[key] = null;
                state.count[key] = null;
              }
            } else {
              state.list = null;
              state.pageInfo = null;
              state.count = null;
            }
          } else {
            if (keyedById) {
              const key = getKeyFromMetaArg(action.meta?.arg);
              if (key !== null) {
                state.data[key] = null;
              }
            } else {
              state.data = null;
            }
          }
        });

      // merge additional reducers
      for (const [key, reducer] of Object.entries(extraReducers)) {
        builder.addCase(key, reducer);
      }
    },
  });

  return slice;
};




// export const createDynamicSlice = ({
//     name,
//     thunk,
//     listMode,
//     resetActionName = null,
// }) => {
//     const initialState = listMode
//         ? {
//             list: null,
//             pageInfo: null,
//             count: null,
//             loading: false,
//             error: null,
//         }
//         : {
//             data: null,
//             loading: false,
//             error: null,
//         };

//     const reducers = resetActionName
//         ? {
//             [resetActionName]: (state) => {
//                 state.loading = false;
//                 state.error = null;
//                 if (listMode) {
//                     state.list = null;
//                     state.pageInfo = null;
//                     state.count = null;
//                 } else {
//                     state.data = null;
//                 }
//             },
//         }
//         : {};

//     return createSlice({
//         name,
//         initialState,
//         reducers,
//         extraReducers: (builder) => {
//             builder
//                 .addCase(thunk.pending, (state) => {
//                     state.loading = true;
//                     state.error = null;
//                 })
//                 .addCase(thunk.fulfilled, (state, action) => {
//                     state.loading = false;
//                     if (listMode === true) {
//                         state.list = action.payload.list;
//                         state.pageInfo = action.payload.pageInfo;
//                         state.count = action.payload.count ?? null;
//                     } else {
//                         state.data = action.payload;
//                     }
//                 })
//                 .addCase(thunk.rejected, (state, action) => {
//                     state.data = null;
//                     state.list = null;
//                     state.loading = false;
//                     state.error =
//                         action.payload || action.error?.message || "Something went wrong";
//                 });
//         },
//     });
// };

export const createMappedContentSlice = (thunk, key = 'contents', dataKey = 'data', resetActionName = null) => {
    const initialState = {
        [key]: {},
    };

    return createSlice({
        name: thunk.typePrefix,
        initialState,
        reducers: resetActionName
            ? {
                [resetActionName]: (state) => {
                    state[key] = {};
                },
            }
            : {},
        extraReducers: (builder) => {
            builder
                .addCase(thunk.pending, (state, action) => {
                    const contentType = action.meta.arg.contentType;
                    state[key][contentType] = {
                        ...(state[key][contentType] || {}),
                        loading: true,
                        error: null,
                    };
                })
                .addCase(thunk.fulfilled, (state, action) => {
                    const { contentType, data } = action.payload;
                    state[key][contentType] = {
                        ...(Array.isArray(data) ? { [dataKey]: data } : data),
                        loading: false,
                        error: null,
                    };
                })
                .addCase(thunk.rejected, (state, action) => {
                    const contentType = action.payload?.contentType || action.meta.arg.contentType;
                    state[key][contentType] = {
                        ...(state[key][contentType] || {}),
                        loading: false,
                        error: action.payload?.message || action.error?.message || 'data error',
                    };
                });
        },
    });
};
